import Reflux from 'reflux';
const HoverAction = Reflux.createActions([
  'pushHoverData',
]);
export default HoverAction;



// WEBPACK FOOTER //
// ./assets/src/frontend/preview/action/hoverAction.js